import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { PostcodeList, SuburbList } from '../../../../models/account-delivery-address';
import { Observable, Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { ShoppingCartService } from '../../../../services/shopping-cart.service';
import { CheckOutService } from '../../../../services/checkout.service';
import { CommonService } from '../../../../services';
import { CurrentUserModel, StateModel } from '../../../../models/account-ledger.model';
import { CirrusTenantResponse } from '../../../../models/check-out.model';
import { ManageService } from '../../../../services/manage.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { DOCUMENT } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-create-cirrus-end-user',
  templateUrl: './create-cirrus-end-user.component.html',
  styleUrls: ['./create-cirrus-end-user.component.css']
})
export class CreateCirrusEndUserComponent implements OnInit, OnDestroy {
  title: string = "New Tenant";
  setFullWindow: boolean = true;
  userFormGroup: FormGroup;
  stateList: string[];
  loadContent: boolean = false;
  programType: string = 'VDC';
  programName: string;
  filteredPostCode: PostcodeList[];
  filteredSub: PostcodeList[];
  user_validation_messages: any = {
    "firstNameField": [
      { class: "firstNameValidate", message: "Please enter first name" }
    ],
    "lastNameField": [
      { class: "lastNameValidate", message: "Please enter last name" }
    ],
    "emailField": [
      { class: "emailValidate", message: "Please enter email" }
    ],
    "companyNameField": [
      { class: "companyNameValidate", message: "Please enter company name" }
    ],
    "companyDescField": [
      { class: "companyDescValidate", message: "Please enter company description" }
    ],
    "addressLine1Field": [
      { class: "addressLine1Validate", message: "Please enter address" }
    ],
    "suburbField": [
      { class: "suburbValidate", message: "Please enter suburb" }
    ],
    "stateField": [
      { class: "stateValidate", message: "Please choose state" }
    ],
    "postcodeField": [
      { class: "postcodeValidate", message: "Please enter postcode" }
    ],
    "phoneField": [
      { class: "phoneValidate", message: "Please enter phone" }
    ],
  };
  public user$: Observable<CurrentUserModel>;

  //unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();
  @ViewChild('myAutocompleteTriggerSub') private _myAutocompleteTriggerSub: MatAutocompleteTrigger;
  @ViewChild('myAutocompleteTriggerPostcode') private _myAutocompleteTriggerPostcode: MatAutocompleteTrigger;
  constructor(
    private router: Router,
    private shoppingCartService: ShoppingCartService,
    private checkOutService: CheckOutService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private manageService: ManageService,
    private commonService: CommonService,
    private authService: AuthService,
    @Inject(DOCUMENT) private _document: Document
  ) {
    this.userFormGroup = this.formBuilder.group({
      userGroup: this.getUserGroup()
    });
  }

  ngOnInit() {
    this.user$ = this.authService.getLoginInfo();
    this.loadContent = false;
    $('#levelOne').animate({ scrollLeft: 250 }, 400);

    this.activatedRoute.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(value => {
      //this.programType = value.get('programType');
      this.programName = value.get('programName');

    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
    this.shoppingCartService.getState().subscribe((res: StateModel) => {
      this.stateList = res.states;
      this.loadContent = true;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  getUserGroup(): FormGroup {
    return this.formBuilder.group({
      firstNameField: new FormControl("", Validators.compose([Validators.required])),
      lastNameField: new FormControl("", Validators.compose([Validators.required])),
      emailField: new FormControl("", this.commonService.emailValidatorRegex()),
      companyNameField: new FormControl("", Validators.compose([Validators.required])),
      companyDescField: new FormControl("", Validators.compose([Validators.required])),
      addressLine1Field: new FormControl("", Validators.compose([Validators.required])),
      addressLine2Field: new FormControl(""),
      addressLine3Field: new FormControl(""),
      suburbField: new FormControl("", Validators.compose([Validators.required])),
      stateField: new FormControl("", Validators.compose([Validators.required])),
      postcodeField: new FormControl("", Validators.compose([Validators.required])),
      phoneField: new FormControl("", Validators.compose([Validators.required])),
      programType: new FormControl("")
    });
  }

  saveEndUser(): void {
    if (this.userFormGroup.get("userGroup").valid) {
      let flag = false;
      if (this.userFormGroup.get('userGroup.postcodeField').value.length < 4) {
        flag = true;
        this.commonService.showValidator('.postcodeValidate', "Please input valid postcode", "right", "error");
      }
      if (!flag) {
        this.loadContent = false;
        if (this.programType === 'VDC') {
          let inputModel = {} as any;
          inputModel = {
            programType: this.programType,
            firstNameField: encodeURIComponent(this.userFormGroup.get('userGroup.firstNameField').value),
            lastNameField: encodeURIComponent(this.userFormGroup.get('userGroup.lastNameField').value),
            emailField: this.userFormGroup.get('userGroup.emailField').value,
            companyNameField: encodeURIComponent(this.userFormGroup.get('userGroup.companyNameField').value),
            addressLine1Field: encodeURIComponent(this.userFormGroup.get('userGroup.addressLine1Field').value),
            addressLine2Field: this.userFormGroup.get('userGroup.addressLine2Field').value,
            addressLine3Field: this.userFormGroup.get('userGroup.addressLine3Field').value,
            suburbField: this.userFormGroup.get('userGroup.suburbField').value,
            stateField: this.userFormGroup.get('userGroup.stateField').value,
            postcodeField: this.userFormGroup.get('userGroup.postcodeField').value,
            phoneField: this.userFormGroup.get('userGroup.phoneField').value
          };
          
          this.manageService.CreateCirrusTenantSubscription(JSON.stringify(inputModel)).subscribe((res: CirrusTenantResponse) => {
            this.loadContent = true;
            if (res.resultStatus == "Success") {
              //this.manageService.monitorAnnuity(res);
              // this.commonService.showSuccess(".saveuser", res.info, "right");
              //this.commonService.implementToast(res.message, "Success");
              this.manageService.getOrRefreshSubscriptionOrderSubject.next();
              this.commonService.implementToast(res.message, "Success");
              setTimeout(() => {
                this.router.navigate([`CIRRUSDetails/${res.tenantId}`], { relativeTo: this.activatedRoute.parent });
                //this.router.navigate([`CIRRUSDetails/2C66A709-1353-4C70-B0C1-CE119B0E3B1B`], { relativeTo: this.activatedRoute.parent });
              }, 1000);
            } else {
              // this.commonService.showError(".saveuser", res.info, "right");
              this.commonService.implementToast(res.message, "Error");
            }
          },
            (error: any) => {
              console.error(error);
              // this.commonService.showError(".saveuser", error.responseMessage, "right");
              this.commonService.implementToast(error.responseMessage, "Error");
              this.loadContent = true;
            });
        } 
      }
    } else {
      this.isNotValidField("userGroup.firstNameField", this.user_validation_messages.firstNameField);
      this.isNotValidField("userGroup.lastNameField", this.user_validation_messages.lastNameField);
      this.isNotValidField("userGroup.emailField", this.user_validation_messages.emailField);
      this.isNotValidField("userGroup.companyNameField", this.user_validation_messages.companyNameField);
      this.isNotValidField("userGroup.companyDescField", this.user_validation_messages.companyDescField);
      this.isNotValidField("userGroup.addressLine1Field", this.user_validation_messages.addressLine1Field);
      this.isNotValidField("userGroup.suburbField", this.user_validation_messages.suburbField);
      this.isNotValidField("userGroup.stateField", this.user_validation_messages.stateField);
      this.isNotValidField("userGroup.postcodeField", this.user_validation_messages.postcodeField);
      this.isNotValidField("userGroup.phoneField", this.user_validation_messages.phoneField);
    }
  }

  chooseAutoComplete(option: PostcodeList): void {
    this.userFormGroup.get('userGroup.postcodeField').setValue(option.postcode);
    this.userFormGroup.get('userGroup.stateField').setValue(option.state);
    this.userFormGroup.get('userGroup.suburbField').setValue(option.suburb);
  }

  chooseAutoCompletPostcode(event: any): void {
    if (this.filteredPostCode) {
      this.userFormGroup.get('userGroup.postcodeField').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('userGroup.stateField').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('userGroup.suburbField').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  chooseAutoCompletSuburb(event: any): void {
    if (this.filteredSub) {
      this.userFormGroup.get('userGroup.postcodeField').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('userGroup.stateField').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('userGroup.suburbField').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  // startFilterSub(): void {
  //   if (this.userFormGroup.get('userGroup.suburbField').value.length > 2) {
  //     this.checkOutService.getSuburbList(this.userFormGroup.get('userGroup.suburbField').value).subscribe((res: SuburbList[]) => {
  //       this.filteredSub = res;
  //     },
  //       (error: any) => {
  //         console.error(error);
  //         this.loadContent = true;
  //       });
  //   }
  // }

  // startFilterPostcode(): void {
  //   if (this.userFormGroup.get('userGroup.postcodeField').value.length > 1) {
  //     this.checkOutService.getPostCodeList(this.userFormGroup.get('userGroup.postcodeField').value).subscribe((res: SuburbList[]) => {
  //       this.filteredPostCode = res;
  //     },
  //       (error: any) => {
  //         console.error(error);
  //         this.loadContent = true;
  //       });
  //   }
  // }

  startFilterPostcode(res: PostcodeList[]): void {
    this.filteredPostCode = res;
  }
  
  startFilterSub(res: PostcodeList[]): void {
    this.filteredSub = res;
  }
  onInputSub(event: KeyboardEvent): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerSub._onChange(target.value);
    }
  }

  onInputPostcode(event: KeyboardEvent): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerPostcode._onChange(target.value);
    }
  }

  isNumberKey(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  isNotValidField(path: string, validation: any): void {
    if (path == "userGroup.email") {
      if (this.userFormGroup.get(path).hasError("required")) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      } else if (this.userFormGroup.get(path).hasError("email")) {
        this.commonService.showValidator("." + validation[0].class, "Please enter a valid email address", "right", "error");
      }
    } else {
      if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      }
    }
  }

  close() {
    let splittedArray = this.router.url.split("/");
    splittedArray.pop();
    let previousUrl = splittedArray.join("/")
    this.router.navigateByUrl(previousUrl);
    $('#levelOne').animate({ scrollLeft: 0 }, 400);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
